import React, { useContext } from "react";
import { compose, graphql } from "react-apollo";
import { FaBullhorn } from "react-icons/fa";
import moment from 'moment';

import MarketingOnlyTable from "./marketing-only-container";
import CreateEditMarketingOnlyWithMutation from "../forms/create-edit-marketing-only-container";
import DashboardContextProvider from "../../../context/dashboard-context-provider";
import * as cardsType from "../../lead/dashboard/lead-card-types";
import { Auth } from "../../../rbac/rbac";
import { getCreateDateFilters } from "../../../utils/helpers";
import { GET_PREVIOUS_CARD } from "../../../cacheql/queries";
import { GET_MARKETING_ONLY_COUNT, GET_DASHBOARD_MARKETING_ONLY } from "../../../graphql/queries";
import ActivityFeedDrawer from "../../activity-feed/activity-feed-drawer";

const activityCards = [
  {
    type: cardsType.TODAY,
    title: 'Today',
    tableTitle: 'New Marketing Only Today',
    customDataQuery: GET_MARKETING_ONLY_COUNT,
    customPath: 'getTotalMarketingOnlyCount',
    description: 'Count includes Marketing Only customers in active communities only.',
    filter: getCreateDateFilters('today'),
  },
  {
    type: cardsType.THIS_MONTH,
    title: moment().format('MMM'),
    tableTitle: 'New Marketing Only This Month',
    description: 'Count includes Marketing Only customers in active communities only.',
    filter: getCreateDateFilters('month'),
    hash: '#month',
    customDataQuery: GET_MARKETING_ONLY_COUNT,
    customPath: 'getTotalMarketingOnlyCount',
    secondaryDataQuery: {
      filter: getCreateDateFilters('prev_year_month'),
      description: 'Count includes Marketing Only customers in active communities only.',
      dataQuery: GET_MARKETING_ONLY_COUNT,
      name: 'getMarketingOnlyCountLastYearMonth',
    },
  },
  {
    type: cardsType.THIS_YEAR,
    title: 'YTD',
    tableTitle: 'New Marketing Only This Year',
    filter: getCreateDateFilters('year'),
    hash: '#year',
    customDataQuery: GET_MARKETING_ONLY_COUNT,
    description: 'Count includes Marketing Only customers in active communities only.',
    customPath: 'getTotalMarketingOnlyCount',
    secondaryDataQuery: {
      filter: getCreateDateFilters('prev_year'),
      dataQuery: GET_MARKETING_ONLY_COUNT,
      name: 'getMarketingOnlyCountLastYear',
    },
  },
  {
    title: 'All',
    tableTitle: 'All Marketing Only',
    customDataQuery: GET_MARKETING_ONLY_COUNT,
    description: 'Count includes Marketing Only customers in active communities only.',
    customPath: 'getTotalMarketingOnlyCount',
  },
];

/**
 * This component is used to render lead dashboard with 3 cards and a table. Each card has same query and its
 * own filter. All the tables render the same table with data change only. This dahsboard contains community
 * dropdown and division dropdown is there for manager role only. By default All leads card is preselected.
 * @param {*} props
 */
const MarketingOnlyDashboard = (props) => {
  const { is_manager, has_multiple_divisions } = useContext(Auth);

  const getDefaultCard = () => {
    const cardTitle = props.getPreviousCard.previousCard.title;
    const index = activityCards.findIndex((item) => item.title === cardTitle);

    if (index === -1)
      return activityCards[3];
    return activityCards[index];
  };

  return (
    <DashboardContextProvider
      type="MarketingOnly"
      text="New Marketing Only"
      startingDefaultCard={getDefaultCard()}
      dataQuery={GET_DASHBOARD_MARKETING_ONLY}
      activityCards={activityCards}
      formContent={CreateEditMarketingOnlyWithMutation}
      icon={FaBullhorn}
      withCommunity
      withDivision={is_manager() || has_multiple_divisions()}
      tableView={<MarketingOnlyTable />}
      {...props}
      secondaryBarButton={{
        drawerClassName: "activity-feed-drawer",
        formContent: (drawerProps) => (
          <ActivityFeedDrawer customerType="Marketing_Only" {...drawerProps} />
        ),
      }}
    />
  );
};

export default compose(graphql(GET_PREVIOUS_CARD, { name: "getPreviousCard" }))(MarketingOnlyDashboard);
